import Link from 'next/link'
import React from 'react'
import { useAppContext } from '../../context/siteMapContext'

const Logo: React.FC = () => {
  const { highContrastOn } = useAppContext();

  return (
    <div className='absolute z-2 top-8 2xl:top-12 left-[calc(50%-40px)] 2xl:left-[calc(50%-70px)]' >
      <Link href='/'>
        <a className='relative z-1 block w-logo h-logo 2xl:w-logo-2xl 2xl:h-logo-2xl'>
          <picture className={`overflow-hidden flex w-full h-full ${highContrastOn ? 'grayscale' : ''}`}>
            <source srcSet='/header/header_logo.svg' type='image/webp' />
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              className='h-full w-full'
              src='/header/header_logo.svg'
              alt='Budapest 18. kerület'
            />
          </picture>
        </a>
      </Link>
    </div>
  )
}

export default Logo
